var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<option value=\"\">Year</option> <option ng-repeat=\"year in years\" value=\"{{ year.value }}\">{{ year.label }}</option>";
ngModule.run(["$templateCache",function(c){c.put("formatters/templates/year.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/templates/year.html
 ** module id = 550
 ** module chunks = 1
 **/